module.exports = "<div class=\"error\">\r\n        <img src=\"" + require("../../assets/images/github-error.png") + "\" height=\"200\" width=\"200\">\r\n        <div class=\"error__title\">Github API Error</div>\r\n        <div class=\"error__message\">\r\n                {{$ctrl.errorMessage}}\r\n        </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./views/error/error.html
// module id = 113
// module chunks = 0